import { Heading } from "@magnetic/heading";
import { Modal } from "@magnetic/modal";

import { Button } from "src/components/buttons";
import { HFlex } from "src/components/hFlex";

type MonitorOverlayProps = {
  readonly title: string;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly actions?: JSX.Element;
  readonly children: JSX.Element;
};

export const MonitorOverlay = (props: MonitorOverlayProps) => {
  const { title, isOpen, onClose, actions, children } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={true} className="cnc-history-monitor-modal">
      <HFlex
        className="cnc-history-monitor-header"
        justify="space-between"
        align="center"
      >
        <Heading>{title}</Heading>
        <HFlex align="center">
          {actions}
          <Button
            name="close-monitor-overlay"
            size="sm"
            kind="tertiary"
            onClick={onClose}
          >
            Close
          </Button>
        </HFlex>
      </HFlex>
      <div className="cnc-history-monitor-body">{children}</div>
    </Modal>
  );
};
